import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function KitStockListMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.kit.stock.list);
  };

  return (
    <MainMenuItem
      itemTitleString="在庫を確認する"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default KitStockListMenuItem;
